import {Component, Injectable, TemplateRef, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {AbstractControl} from "@angular/forms";
import {ToastService} from "@app/_services/toast.service";

@Component({
    selector: 'app-modal-confirm',
    imports: [],
    templateUrl: './modal-confirm.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./modal-confirm.component.scss', '../../app.component.scss']
})
@Injectable()
export class ModalConfirmComponent {
    @ViewChild('modal') private modal!: TemplateRef<ModalConfirmComponent>
    protected message: string = "";
    protected data: string | null = null;
    public modalRef!: NgbModalRef

    constructor(private modalService: NgbModal, private toastService: ToastService) {
    }

    open(message: string, data: string | null = null) {
        this.message = message;
        this.data = data;

        this.modalRef = this.modalService.open(this.modal, {
            modalDialogClass: "modal-dialog-centered",
            backdrop: "static",
        });
    }

    async close() {
        this.modalRef.close("yes");
    }

    async dismiss(): Promise<void> {
        this.modalRef.dismiss("no");
    }

    confirmIfDirty(form: AbstractControl, onConfirm: () => void) {
        if (!form.dirty) {
            onConfirm();
            return;
        }

        this.open("You have unsaved changes. Do you really want to close?");
        this.modalRef.result.then(onConfirm, () => {
        }).catch(error => {
            console.error("Error while closing after unsaved-changes confirmation:", error);
            this.toastService.showDanger("Error", "Something went wrong while closing. Please try again.");
        });
    }
}
